module.exports = __webpack_public_path__ + "img/Domo.da807f69.jpeg";